export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11842.402c4b47.jpg";